import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

export const entryShareUrl = (entryId) => `${window.location.origin}/top-badge?entry=${entryId}`;

// Copies (or natively shares) a deep link to one campaign entry so entrants can rally votes.
export default function TopBadgeShareButton({ entryId, name, className = "", variant = "ghost", size = "sm", label = "Share" }) {
  const share = async () => {
    const url = entryShareUrl(entryId);
    const payload = { title: "Vote for me — Top Badge Kickoff", text: `Vote for ${name || "my entry"} in the My Panda X Top Badge Kickoff!`, url };
    try {
      if (navigator.share && navigator.canShare?.(payload)) { await navigator.share(payload); return; }
      await navigator.clipboard.writeText(url);
      toast.success("Link copied — paste it anywhere to rally votes.");
    } catch (e) {
      if (e?.name === "AbortError") return;
      toast.error("Could not copy the link.");
    }
  };
  return (
    <Button size={size} variant={variant} onClick={share} className={className} data-testid={`top-badge-share-${entryId}`} aria-label={`Share ${name || "entry"}`}>
      <Share2 size={13} className="mr-1.5" />{label}
    </Button>
  );
}
